<template lang="pug">
  #QuinielaFixture
    Header

    div.breadcrumb-bar
      v-container(fluid)
        v-row(justify='center')
          v-col(cols='11')
            div.breadcrumb-inner
              a.bread-link(href='/') Inicio
              span.bread-sep /
              span.bread-current Quiniela Mundial 2026

    //- ── HERO BANNER ─────────────────────────────────────────────────────────
    div.quin-hero-banner
      //- Fondo campo de fútbol SVG
      div.quin-field-bg
        svg(viewBox='0 0 800 400' xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMidYMid slice')
          rect(width='800' height='400' fill='none')
          //- Líneas del campo
          rect(x='40' y='40' width='720' height='320' rx='4' fill='none' stroke='rgba(255,255,255,0.08)' stroke-width='2')
          line(x1='400' y1='40' x2='400' y2='360' stroke='rgba(255,255,255,0.08)' stroke-width='2')
          circle(cx='400' cy='200' r='60' fill='none' stroke='rgba(255,255,255,0.08)' stroke-width='2')
          circle(cx='400' cy='200' r='5' fill='rgba(255,255,255,0.1)')
          rect(x='40' y='140' width='90' height='120' rx='2' fill='none' stroke='rgba(255,255,255,0.07)' stroke-width='2')
          rect(x='670' y='140' width='90' height='120' rx='2' fill='none' stroke='rgba(255,255,255,0.07)' stroke-width='2')
          rect(x='40' y='165' width='40' height='70' rx='2' fill='none' stroke='rgba(255,255,255,0.07)' stroke-width='2')
          rect(x='720' y='165' width='40' height='70' rx='2' fill='none' stroke='rgba(255,255,255,0.07)' stroke-width='2')
          circle(cx='130' cy='200' r='25' fill='none' stroke='rgba(255,255,255,0.06)' stroke-width='1.5')
          circle(cx='670' cy='200' r='25' fill='none' stroke='rgba(255,255,255,0.06)' stroke-width='1.5')
      //- Hexágonos decorativos tipo balón
      div.quin-hex-deco
        span.hex h1
        span.hex h2
        span.hex h3
        span.hex h4
        span.hex h5
      v-container(fluid style='position:relative;z-index:2;')
        v-row(justify='center')
          v-col(cols='12' sm='10' md='8' style='text-align:center;padding:52px 16px 36px;')
            div.quin-hero-badge
              span.quin-trophy ⚽
              span FIFA WORLD CUP 2026
              span.quin-trophy ⚽
            h1.quin-hero-title
              | Quiniela
              span.quin-hero-title-accent  Mundial
            p.quin-hero-sub Usa tus tickets de compra para pronosticar los partidos del Mundial y ganar premios
            div.quin-hero-cta(v-if='!usuarioLogueado')
              v-btn(color='white' style='color:#0d3b1e;font-weight:800;border-radius:30px;padding:0 32px;font-size:15px;letter-spacing:0.5px;' x-large @click="$router.push('/ingreso')")
                v-icon(left) mdi-login
                | Ingresar para jugar
            div.quin-hero-stats(v-if='usuarioLogueado')
              div.quin-stat
                span.quin-stat-emoji 🎟️
                span.quin-stat-val {{ ticketsPendientes.length }}
                span.quin-stat-lbl Tickets
              div.quin-stat-div
              div.quin-stat
                span.quin-stat-emoji ⚽
                span.quin-stat-val {{ misApuestas.length }}
                span.quin-stat-lbl Apuestas
              div.quin-stat-div
              div.quin-stat
                span.quin-stat-emoji 🏆
                span.quin-stat-val {{ misApuestas.reduce((s,a) => s + (a.puntos_total || 0), 0) }}
                span.quin-stat-lbl Puntos
      //- Ola inferior
      div.quin-hero-wave
        svg(viewBox='0 0 1440 60' xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none')
          path(d='M0,30 C360,60 1080,0 1440,30 L1440,60 L0,60 Z' fill='#f0f4f0')

    div.quiniela-page
      v-container(fluid)
        v-row(justify='center')
          v-col(cols='12' sm='11' md='10')

            //- ── REGLAS ─────────────────────────────────────────────────────────
            div.quin-rules-section
              div.quin-rules-header
                v-icon(color='#FF6200' size='20') mdi-information-outline
                span Cómo funciona la Quiniela
              div.quin-rules-grid
                //- Cómo obtener tickets
                div.quin-rule-card.accent
                  div.quin-rule-icon-wrap
                    v-icon(color='white' size='26') mdi-ticket-confirmation
                  div.quin-rule-body
                    h4.quin-rule-title Obtén tus tickets
                    p.quin-rule-text Por cada compra que realices en Fercoven recibes tickets automáticamente. ¡Más compras = más oportunidades!
                //- Cómo apostar
                div.quin-rule-card
                  div.quin-rule-icon-wrap.orange
                    v-icon(color='white' size='26') mdi-soccer
                  div.quin-rule-body
                    h4.quin-rule-title Apuesta en partidos
                    p.quin-rule-text Elige un partido, ingresa tu pronóstico de goles y selecciona cuántos tickets quieres apostar. Un ticket por partido, pero puedes apostar varios al mismo.
                //- Sistema de puntos
                div.quin-rule-card
                  div.quin-rule-icon-wrap.dark
                    v-icon(color='white' size='26') mdi-star-circle
                  div.quin-rule-body
                    h4.quin-rule-title Acumula puntos
                    p.quin-rule-text Según tu acierto ganas puntos. Los puntos se multiplican por la cantidad de tickets apostados en ese partido.

              //- Tabla de puntos
              div.quin-pts-table
                div.quin-pts-header
                  v-icon(size='16' color='#FF6200') mdi-trophy-outline
                  span Sistema de puntuación
                div.quin-pts-grid
                  div.quin-pts-row.gold
                    div.quin-pts-left
                      v-icon(size='18' color='#FFB800') mdi-check-circle
                      span Resultado exacto
                    div.quin-pts-badge 3 pts
                  div.quin-pts-row
                    div.quin-pts-left
                      v-icon(size='18' color='#FF6200') mdi-approximately-equal
                      span Diferencia de goles correcta
                    div.quin-pts-badge.orange 2 pts
                  div.quin-pts-row
                    div.quin-pts-left
                      v-icon(size='18' color='#555') mdi-flag-checkered
                      span Solo ganador correcto
                    div.quin-pts-badge.grey 1 pt
                  div.quin-pts-row.bonus
                    div.quin-pts-left
                      v-icon(size='18' color='#9C27B0') mdi-lightning-bolt
                      span Bonus fase eliminatoria
                    div.quin-pts-badge.purple +1 pt
                div.quin-pts-note
                  v-icon(size='13' color='#999') mdi-information
                  span Los puntos se multiplican por la cantidad de tickets apostados en ese partido

            //- ── TABS NAV ────────────────────────────────────────────────────────
            div.quin-nav
              button.quin-nav-btn(:class="{ active: tabActivo === 'partidos' }" @click="tabActivo='partidos'")
                v-icon(size='16') mdi-calendar-check
                span Partidos
              button.quin-nav-btn(:class="{ active: tabActivo === 'tickets' }" @click="tabActivo='tickets'")
                v-icon(size='16') mdi-ticket-confirmation
                span Mis Tickets
              button.quin-nav-btn(:class="{ active: tabActivo === 'apuestas' }" @click="tabActivo='apuestas'")
                v-icon(size='16') mdi-soccer
                span Mis Apuestas
              button.quin-nav-btn(:class="{ active: tabActivo === 'tabla' }" @click="tabActivo='tabla'")
                v-icon(size='16') mdi-podium
                span Tabla

            //- ── PARTIDOS ────────────────────────────────────────────────────────
            div(v-if="tabActivo === 'partidos'")
              div(v-if='loading' style='text-align:center;padding:60px;')
                div.quin-loading-ball ⚽
                v-progress-circular(indeterminate color='#1a7a3c' size='48')
              div(v-else)
                div(v-for='(grupo, fase) in partidosPorFase' :key='fase')
                  div.quin-fase-title(:class='`fase-${fase}`')
                    span.quin-fase-icon {{ faseEmoji(fase) }}
                    span {{ faseLabel(fase) }}
                  div.quin-partido-card(
                    v-for='partido in grupo'
                    :key='partido._id'
                    :class="{ 'card-finalizado': partido.estado === 'finalizado', 'card-vivo': partido.estado === 'en_juego' }"
                  )
                    div.quin-partido-topbar
                      span.quin-partido-fecha ⏱ {{ partido.fecha | moment('ddd DD MMM · HH:mm') }}
                      span.quin-estado-badge(:class='partido.estado') {{ estadoLabel(partido.estado) }}
                    div.quin-partido-inner
                      div.quin-equipo
                        div.quin-bandera-wrap
                          img(v-if='partido.bandera_local' :src='partido.bandera_local')
                          div.quin-bandera-ph(v-else) {{ (partido.nombre_local || 'TBD').substring(0,3).toUpperCase() }}
                        span.quin-equipo-nombre {{ partido.nombre_local }}
                      div.quin-centro
                        div.quin-marcador(v-if="partido.estado === 'finalizado'")
                          span {{ partido.resultado.goles_local }}
                          span.quin-sep -
                          span {{ partido.resultado.goles_visitante }}
                        div.quin-live-wrap(v-else-if="partido.estado === 'en_juego'")
                          span.quin-live-dot
                          span.quin-live-text EN VIVO
                        div.quin-vs-wrap(v-else)
                          span.quin-vs VS
                      div.quin-equipo.derecha
                        div.quin-bandera-wrap
                          img(v-if='partido.bandera_visitante' :src='partido.bandera_visitante')
                          div.quin-bandera-ph(v-else) {{ (partido.nombre_visitante || 'TBD').substring(0,3).toUpperCase() }}
                        span.quin-equipo-nombre {{ partido.nombre_visitante }}
                    div.quin-apostar-footer(v-if="partido.estado === 'pendiente' && usuarioLogueado")
                      div.quin-apuesta-badge(v-if='miApuesta(partido._id)')
                        v-icon(size='15' color='#1a7a3c') mdi-check-decagram
                        | Apostado: {{ miApuesta(partido._id).pronostico.goles_local }}-{{ miApuesta(partido._id).pronostico.goles_visitante }}
                        span.quin-apuesta-ticks  · {{ miApuesta(partido._id).tickets.length }} ticket{{ miApuesta(partido._id).tickets.length > 1 ? 's' : '' }}
                      div(v-else-if='!puedeApostar(partido)' style='font-size:12px;color:#e53935;font-weight:600;')
                        v-icon(size='14' color='#e53935') mdi-lock-clock
                        |  Apuestas cerradas
                      v-btn(v-else small class='quin-btn-apostar' dark @click='irApostar(partido)')
                        v-icon(left size='15') mdi-soccer
                        | Apostar

            //- ── MIS TICKETS ─────────────────────────────────────────────────────
            div(v-if="tabActivo === 'tickets'")
              div.quin-locked(v-if='!usuarioLogueado')
                span(style='font-size:48px;') 🔒
                p Debes iniciar sesión para ver tus tickets
                v-btn(color='#1a7a3c' dark rounded href='/ingreso') Iniciar sesión
              div(v-else-if='loadingTickets' style='text-align:center;padding:40px;')
                v-progress-circular(indeterminate color='#1a7a3c')
              div(v-else)
                div.quin-tickets-header
                  span 🎟️ {{ ticketsPendientes.length }} ticket{{ticketsPendientes.length !== 1 ? 's' : ''}} disponibles
                div.quin-tickets-grid
                  div.quin-ticket(v-for='tick in ticketsPendientes' :key='tick._id')
                    div.quin-ticket-punch
                    span.quin-tick-nro {{ '#' + tick.nro }}
                    span.quin-tick-label TICKET
                    span.quin-tick-fecha {{ tick.fecha | moment('DD/MM/YYYY') }}
                div.quin-empty(v-if='ticketsPendientes.length === 0')
                  span(style='font-size:40px;') 🎟️
                  p No tienes tickets disponibles. Realiza compras para obtener tickets.

            //- ── MIS APUESTAS ────────────────────────────────────────────────────
            div(v-if="tabActivo === 'apuestas'")
              div.quin-locked(v-if='!usuarioLogueado')
                span(style='font-size:48px;') 🔒
                p Debes iniciar sesión
                v-btn(color='#1a7a3c' dark rounded href='/ingreso') Iniciar sesión
              div(v-else-if='loadingApuestas' style='text-align:center;padding:40px;')
                v-progress-circular(indeterminate color='#1a7a3c')
              div.quin-empty(v-else-if='misApuestas.length === 0')
                span(style='font-size:40px;') ⚽
                p Aún no has hecho apuestas. ¡Ve a Partidos y empieza a jugar!
              div(v-else)
                div.quin-apuesta-row(v-for='ap in misApuestas' :key='ap._id' :class="ap.puntos_total > 0 ? 'con-puntos' : ''")
                  div.quin-apuesta-banderas(v-if='ap.partido_id')
                    img(v-if='ap.partido_id.bandera_local' :src='ap.partido_id.bandera_local' style='height:22px;border-radius:2px;')
                    span.quin-apuesta-separador ⚔
                    img(v-if='ap.partido_id.bandera_visitante' :src='ap.partido_id.bandera_visitante' style='height:22px;border-radius:2px;')
                  div.quin-apuesta-info
                    span.quin-apuesta-partido(v-if='ap.partido_id') {{ ap.partido_id.nombre_local }} vs {{ ap.partido_id.nombre_visitante }}
                    span.quin-apuesta-prono ⚽ Pronóstico: {{ ap.pronostico.goles_local }} - {{ ap.pronostico.goles_visitante }}
                    span.quin-apuesta-tickets 🎟️ {{ ap.tickets.length }} ticket{{ ap.tickets.length > 1 ? 's' : '' }}: {{ ap.tickets.join(', ') }}
                  div.quin-apuesta-puntos
                    div(v-if='ap.puntos_total !== null')
                      strong {{ ap.puntos_total }}
                      span pts
                    div.quin-pend-chip(v-else) ⏳ Pendiente

            //- ── TABLA ────────────────────────────────────────────────────────────
            div(v-if="tabActivo === 'tabla'")
              div(v-if='loadingTabla' style='text-align:center;padding:40px;')
                v-progress-circular(indeterminate color='#1a7a3c')
              div.quin-empty(v-else-if='tabla.length === 0')
                span(style='font-size:40px;') 🏆
                p Aún no hay posiciones. ¡Empieza a apostar!
              div(v-else)
                div.quin-tabla-header
                  span # Pos
                  span Jugador
                  span Puntos
                  span Apuestas
                div.quin-tabla-row(
                  v-for='(item, i) in tabla'
                  :key='item._id'
                  :class="{ 'quin-tabla-yo': item._id === coCli, 'pos-1': i===0, 'pos-2': i===1, 'pos-3': i===2 }"
                )
                  span.quin-tabla-pos
                    span(v-if='i===0') 🥇
                    span(v-else-if='i===1') 🥈
                    span(v-else-if='i===2') 🥉
                    span(v-else) {{ i + 1 }}
                  span.quin-tabla-nombre {{ item.cliente }}
                  span.quin-tabla-pts
                    strong {{ item.puntos || 0 }}
                    span pts
                  span.quin-tabla-apuestas {{ item.apuestas }} ap.

    //- ── MODAL APOSTAR ────────────────────────────────────────────────────────
    v-dialog(v-model='dialogApostar' max-width='480px')
      v-card(style='border-radius:18px;overflow:hidden;')
        v-card-title(style='background:linear-gradient(135deg,#0d3b1e,#1a7a3c);padding:18px 24px;')
          span(style='color:white;font-weight:800;font-size:16px;') ⚽ Apostar en partido
        v-card-text(style='padding:24px;')
          div(v-if='partidoActual' style='text-align:center;margin-bottom:20px;background:#f5fbf6;border-radius:12px;padding:14px;border:1px solid #c8e6c9;')
            div(style='font-size:16px;font-weight:800;color:#0d3b1e;') {{ partidoActual.nombre_local }}
              span(style='color:#aaa;font-weight:400;font-size:13px;')  vs
              | {{ partidoActual.nombre_visitante }}
            div(style='font-size:12px;color:#888;margin-top:4px;') {{ partidoActual.fecha | moment('dddd DD MMM · HH:mm') }}
          div(style='margin-bottom:16px;')
            div(style='font-size:12px;font-weight:700;color:#0d3b1e;text-transform:uppercase;letter-spacing:1px;margin-bottom:10px;') Tu pronóstico
            v-layout(row wrap)
              v-flex(xs6 style='padding-right:8px;')
                v-text-field(outlined v-model.number='apuestaForm.goles_local' :label="'Goles ' + (partidoActual ? partidoActual.nombre_local : '')" type='number' min='0' dense color='#1a7a3c')
              v-flex(xs6)
                v-text-field(outlined v-model.number='apuestaForm.goles_visitante' :label="'Goles ' + (partidoActual ? partidoActual.nombre_visitante : '')" type='number' min='0' dense color='#1a7a3c')
          div
            div(style='font-size:12px;font-weight:700;color:#0d3b1e;text-transform:uppercase;letter-spacing:1px;margin-bottom:10px;') 🎟️ Selecciona tickets
            div.quin-tickets-select
              div.quin-tick-opt(
                v-for='tick in ticketsPendientes'
                :key='tick._id'
                :class="{ selected: apuestaForm.ticketsSeleccionados.includes(tick.nro) }"
                @click='toggleTicket(tick.nro)'
              )
                v-icon(:color="apuestaForm.ticketsSeleccionados.includes(tick.nro) ? '#1a7a3c' : 'grey'" size='18') mdi-ticket-confirmation
                span {{ '#' + tick.nro }}
            div(v-if='ticketsPendientes.length === 0')
              p.grey--text(style='font-size:13px;') No tienes tickets disponibles.
        v-card-actions(style='padding:0 24px 20px;gap:8px;')
          v-spacer
          v-btn(text @click='dialogApostar = false' style='color:#888;') Cancelar
          v-btn(style='background:linear-gradient(135deg,#1a7a3c,#25a455);border-radius:20px;font-weight:700;' dark @click='confirmarApuesta' :loading='apostando' :disabled='apuestaForm.ticketsSeleccionados.length === 0')
            v-icon(left size='16') mdi-soccer
            | Confirmar Apuesta

    Footer
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Api from '@/services/methods'
import { mapState } from 'vuex'
export default {
  name: 'QuinielaFixture',
  components: { Header, Footer },
  data () {
    return {
      tabActivo: 'partidos',
      loading: false,
      loadingTickets: false,
      loadingApuestas: false,
      loadingTabla: false,
      partidos: [],
      ticketsPendientes: [],
      misApuestas: [],
      tabla: [],
      dialogApostar: false,
      partidoActual: null,
      apostando: false,
      apuestaForm: {
        goles_local: 0,
        goles_visitante: 0,
        ticketsSeleccionados: []
      }
    }
  },
  computed: {
    ...mapState(['fercoWeb']),
    usuarioLogueado () {
      return this.fercoWeb && this.fercoWeb.co_cli
    },
    coCli () {
      return this.fercoWeb ? this.fercoWeb.co_cli : null
    },
    partidosPorFase () {
      return this.partidos.reduce((acc, p) => {
        if (!acc[p.fase]) acc[p.fase] = []
        acc[p.fase].push(p)
        return acc
      }, {})
    }
  },
  watch: {
    tabActivo (val) {
      if (val === 'tickets' && this.usuarioLogueado && this.ticketsPendientes.length === 0) this.cargarTickets()
      if (val === 'apuestas' && this.usuarioLogueado && this.misApuestas.length === 0) this.cargarMisApuestas()
      if (val === 'tabla' && this.tabla.length === 0) this.cargarTabla()
      if (val === 'partidos') this.cargarPartidos()
    }
  },
  created () {
    this.cargarPartidos()
    if (this.usuarioLogueado) {
      this.cargarTickets()
      this.cargarMisApuestas()
    }
  },
  methods: {
    cargarPartidos () {
      this.loading = true
      Api.get('quiniela/partidos').then(res => {
        this.partidos = res.data
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    cargarTickets () {
      if (!this.coCli) return
      this.loadingTickets = true
      Api.get('tickets/cliente/' + this.coCli.trim()).then(res => {
        this.ticketsPendientes = (res.data || []).filter(t => t.estatus === 'Pendiente')
        this.loadingTickets = false
      }).catch(() => { this.loadingTickets = false })
    },
    cargarMisApuestas () {
      if (!this.coCli) return
      this.loadingApuestas = true
      Api.get('quiniela/apuestas/cliente/' + this.coCli.trim()).then(res => {
        this.misApuestas = res.data
        this.loadingApuestas = false
      }).catch(() => { this.loadingApuestas = false })
    },
    cargarTabla () {
      this.loadingTabla = true
      Api.get('quiniela/tabla').then(res => {
        this.tabla = res.data
        this.loadingTabla = false
      }).catch(() => { this.loadingTabla = false })
    },
    irApostar (partido) {
      if (!this.usuarioLogueado) {
        this.$swal.fire('Inicia sesión', 'Debes iniciar sesión para apostar.', 'info')
        return
      }
      this.partidoActual = partido
      this.apuestaForm = { goles_local: 0, goles_visitante: 0, ticketsSeleccionados: [] }
      this.dialogApostar = true
    },
    toggleTicket (nro) {
      const idx = this.apuestaForm.ticketsSeleccionados.indexOf(nro)
      if (idx >= 0) {
        this.apuestaForm.ticketsSeleccionados.splice(idx, 1)
      } else {
        this.apuestaForm.ticketsSeleccionados.push(nro)
      }
    },
    confirmarApuesta () {
      if (!this.partidoActual || this.apuestaForm.ticketsSeleccionados.length === 0) return
      this.apostando = true
      Api.post('quiniela/apostar', {
        co_cli: this.coCli.trim(),
        cliente: this.fercoWeb.nombre,
        partido_id: this.partidoActual._id,
        tickets: this.apuestaForm.ticketsSeleccionados,
        pronostico: {
          goles_local: this.apuestaForm.goles_local,
          goles_visitante: this.apuestaForm.goles_visitante
        }
      }).then(() => {
        this.apostando = false
        this.dialogApostar = false
        this.$swal.fire('¡Apuesta registrada!', 'Tu pronóstico fue guardado exitosamente.', 'success')
        this.cargarTickets()
        this.cargarMisApuestas()
      }).catch(err => {
        this.apostando = false
        const msg = err.response && err.response.data ? err.response.data.message || 'Error al registrar la apuesta.' : 'Error al registrar la apuesta.'
        this.$swal.fire('Error', msg, 'error')
      })
    },
    miApuesta (partidoId) {
      return this.misApuestas.find(a => a.partido_id && a.partido_id._id === partidoId)
    },
    puedeApostar (partido) {
      if (!partido || !partido.fecha) return false
      const ahora = new Date()
      const fechaPartido = new Date(partido.fecha)
      const diffMs = fechaPartido - ahora
      return diffMs > 60 * 60 * 1000 // más de 1 hora hasta el partido
    },
    faseLabel (f) {
      const m = { grupos: 'Fase de Grupos', octavos: 'Octavos de Final', cuartos: 'Cuartos de Final', semis: 'Semifinales', tercer_puesto: 'Tercer Puesto', final: 'Final' }
      return m[f] || f
    },
    faseEmoji (f) {
      const m = { grupos: '⚽', octavos: '🏆', cuartos: '⚡', semis: '🔥', tercer_puesto: '🥉', final: '🌟' }
      return m[f] || '⚽'
    },
    estadoColor (e) {
      return e === 'finalizado' ? 'green' : e === 'en_juego' ? 'orange' : 'grey darken-1'
    },
    estadoLabel (e) {
      return e === 'finalizado' ? 'Finalizado' : e === 'en_juego' ? 'En juego' : 'Pendiente'
    }
  }
}
</script>

<style lang="scss">
// ── VARIABLES MUNDIAL ─────────────────────────────────────────────────────────
$verde:   #1a7a3c;
$verde2:  #25a455;
$verde-dark: #0d3b1e;
$dorado:  #FFD700;
$gris-bg: #f0f4f0;

// ── HERO BANNER ──────────────────────────────────────────────────────────────
.quin-hero-banner {
  position: relative;
  background: linear-gradient(160deg, #0d3b1e 0%, #1a7a3c 55%, #0f5c2a 100%);
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    top: -60px; right: -60px;
    width: 280px; height: 280px;
    border-radius: 50%;
    background: rgba(255,215,0,0.08);
  }
  &::after {
    content: '';
    position: absolute;
    bottom: -80px; left: -80px;
    width: 260px; height: 260px;
    border-radius: 50%;
    background: rgba(0,0,0,0.15);
  }
}
// Campo de fútbol SVG de fondo
.quin-field-bg {
  position: absolute;
  inset: 0;
  svg { width: 100%; height: 100%; }
}
// Hexágonos tipo balón
.quin-hex-deco {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
  .hex {
    position: absolute;
    width: 40px; height: 46px;
    background: rgba(255,255,255,0.04);
    clip-path: polygon(50% 0%,100% 25%,100% 75%,50% 100%,0% 75%,0% 25%);
    font-size: 0;
    &.h1 { top: 10%; left: 5%;  width: 50px; height: 58px; }
    &.h2 { top: 60%; left: 2%;  width: 30px; height: 34px; background: rgba(255,215,0,0.07); }
    &.h3 { top: 20%; right: 8%; width: 60px; height: 69px; }
    &.h4 { top: 70%; right: 5%; width: 35px; height: 40px; background: rgba(255,215,0,0.06); }
    &.h5 { top: 45%; right: 20%; width: 20px; height: 23px; }
  }
}
.quin-hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255,215,0,0.15);
  border: 1px solid rgba(255,215,0,0.4);
  border-radius: 20px;
  padding: 5px 18px;
  font-size: 11px;
  font-weight: 700;
  color: $dorado;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-bottom: 20px;
}
.quin-trophy { font-size: 14px; }
.quin-hero-title {
  font-size: 42px;
  font-weight: 900;
  color: white;
  margin: 0 0 14px;
  line-height: 1.05;
  letter-spacing: -1px;
  text-shadow: 0 2px 20px rgba(0,0,0,0.3);
  @media (max-width: 600px) { font-size: 28px; }
}
.quin-hero-title-accent {
  color: $dorado;
  font-style: italic;
}
.quin-hero-sub {
  font-size: 15px;
  color: rgba(255,255,255,0.75);
  max-width: 520px;
  margin: 0 auto 28px;
  line-height: 1.6;
}
.quin-hero-cta { margin-top: 8px; }
.quin-hero-wave {
  position: absolute;
  bottom: 0; left: 0; right: 0;
  svg { display: block; width: 100%; height: 60px; }
}
.quin-hero-stats {
  display: inline-flex;
  align-items: center;
  gap: 0;
  background: rgba(0,0,0,0.25);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255,255,255,0.15);
  border-radius: 20px;
  padding: 16px 28px;
  margin-top: 8px;
}
.quin-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 22px;
  gap: 2px;
}
.quin-stat-emoji { font-size: 20px; line-height: 1; }
.quin-stat-val {
  font-size: 30px;
  font-weight: 900;
  color: $dorado;
  line-height: 1;
}
.quin-stat-lbl {
  font-size: 10px;
  color: rgba(255,255,255,0.6);
  text-transform: uppercase;
  letter-spacing: 1px;
  white-space: nowrap;
}
.quin-stat-div {
  width: 1px;
  height: 40px;
  background: rgba(255,255,255,0.15);
}

// ── PAGE WRAPPER ─────────────────────────────────────────────────────────────
.quiniela-page {
  min-height: 70vh;
  background: $gris-bg;
  padding: 32px 0 48px;
}

// ── LOADING BALL ──────────────────────────────────────────────────────────────
.quin-loading-ball {
  font-size: 40px;
  animation: spin-ball 1.2s linear infinite;
  display: block;
  margin-bottom: 12px;
}
@keyframes spin-ball {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

// ── ESTADO VACÍO / BLOQUEADO ──────────────────────────────────────────────────
.quin-empty, .quin-locked {
  text-align: center;
  padding: 48px 20px;
  p { color: #888; margin-top: 12px; font-size: 14px; }
}

// ── RULES SECTION ─────────────────────────────────────────────────────────────
.quin-rules-section {
  background: white;
  border-radius: 18px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.06);
  border-top: 4px solid $verde;
}
.quin-rules-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 800;
  color: $verde-dark;
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  span { color: #333; }
}
.quin-rules-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 14px;
  margin-bottom: 20px;
}
.quin-rule-card {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  background: #f5faf6;
  border-radius: 14px;
  padding: 16px;
  border: 1px solid #d4ead9;
  &.accent { background: #f0f9f3; border-color: #a8d9b5; }
}
.quin-rule-icon-wrap {
  width: 48px; height: 48px;
  border-radius: 14px;
  background: $verde;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
  &.orange { background: #e8a020; }
  &.dark { background: $verde-dark; }
}
.quin-rule-body { flex: 1; }
.quin-rule-title {
  font-size: 13px;
  font-weight: 700;
  color: $verde-dark;
  margin: 0 0 4px;
}
.quin-rule-text {
  font-size: 12px;
  color: #666;
  line-height: 1.5;
  margin: 0;
}

// ── POINTS TABLE ──────────────────────────────────────────────────────────────
.quin-pts-table {
  background: white;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid #d4ead9;
}
.quin-pts-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 11px 16px;
  background: $verde-dark;
  font-size: 13px;
  font-weight: 700;
  color: $dorado;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.quin-pts-grid { padding: 8px; display: flex; flex-direction: column; gap: 4px; }
.quin-pts-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-radius: 8px;
  background: #f8fbf8;
  &.gold { background: #fffdf0; }
  &.bonus { background: #f5f0ff; }
}
.quin-pts-left {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #333;
  font-weight: 500;
}
.quin-pts-badge {
  font-size: 12px;
  font-weight: 800;
  padding: 4px 14px;
  border-radius: 20px;
  background: $verde;
  color: white;
  white-space: nowrap;
  &.orange { background: #e8a020; }
  &.grey { background: #888; }
  &.purple { background: #7B1FA2; }
}
.quin-pts-note {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  font-size: 11px;
  color: #999;
}

// ── TABS NAV ──────────────────────────────────────────────────────────────────
.quin-nav {
  display: flex;
  gap: 4px;
  margin-bottom: 22px;
  background: white;
  border-radius: 16px;
  padding: 6px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.07);
  overflow-x: auto;
}
.quin-nav-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 14px;
  border: none;
  background: transparent;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 700;
  color: #888;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  outline: none;
  .v-icon { color: #bbb; transition: color 0.2s; }
  &.active {
    background: linear-gradient(135deg, $verde, $verde2);
    color: white;
    box-shadow: 0 4px 14px rgba(26,122,60,0.35);
    .v-icon { color: white !important; }
  }
  &:not(.active):hover {
    background: #edf7f0;
    color: $verde;
    .v-icon { color: $verde !important; }
  }
  @media (max-width: 480px) { font-size: 12px; padding: 8px 10px; }
}

// ── FASE TITLE ────────────────────────────────────────────────────────────────
.quin-fase-title {
  font-size: 11px;
  font-weight: 800;
  color: $verde;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin: 26px 0 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  .quin-fase-icon { font-size: 16px; }
  &::after {
    content: '';
    flex: 1;
    height: 2px;
    background: linear-gradient(to right, rgba(26,122,60,0.3), transparent);
    border-radius: 2px;
  }
  &.fase-final { color: #c8951a; &::after { background: linear-gradient(to right, rgba(200,149,26,0.4), transparent); } }
  &.fase-semis { color: #c0392b; &::after { background: linear-gradient(to right, rgba(192,57,43,0.3), transparent); } }
  &.fase-cuartos { color: #8e44ad; &::after { background: linear-gradient(to right, rgba(142,68,173,0.3), transparent); } }
  &.fase-octavos { color: #2980b9; &::after { background: linear-gradient(to right, rgba(41,128,185,0.3), transparent); } }
}

// ── PARTIDO CARD ──────────────────────────────────────────────────────────────
.quin-partido-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  margin-bottom: 12px;
  overflow: hidden;
  transition: box-shadow 0.2s, transform 0.2s;
  border-left: 4px solid #e0e0e0;
  &:hover { box-shadow: 0 6px 24px rgba(0,0,0,0.1); transform: translateY(-1px); }
  &.card-finalizado { border-left-color: $verde; }
  &.card-vivo {
    border-left-color: #e74c3c;
    box-shadow: 0 0 0 2px rgba(231,76,60,0.2), 0 4px 16px rgba(0,0,0,0.1);
    animation: pulse-live 2s ease-in-out infinite;
  }
}
@keyframes pulse-live {
  0%, 100% { box-shadow: 0 0 0 2px rgba(231,76,60,0.2), 0 4px 16px rgba(0,0,0,0.1); }
  50%       { box-shadow: 0 0 0 4px rgba(231,76,60,0.35), 0 4px 16px rgba(0,0,0,0.1); }
}
.quin-partido-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 16px;
  background: #f7fbf7;
  border-bottom: 1px solid #efefef;
}
.quin-partido-fecha {
  font-size: 11px;
  color: #777;
  font-weight: 600;
}
.quin-estado-badge {
  font-size: 10px;
  font-weight: 700;
  padding: 2px 10px;
  border-radius: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  &.pendiente { background: #e8f5e9; color: $verde; }
  &.en_juego  { background: #fde8e8; color: #c0392b; }
  &.finalizado { background: #e8f5e9; color: #1a5c2e; }
}
.quin-partido-inner {
  display: flex;
  align-items: center;
  padding: 18px 20px;
  gap: 8px;
}
.quin-equipo {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  &.derecha { align-items: center; }
}
.quin-bandera-wrap {
  width: 56px; height: 40px;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  display: flex; align-items: center; justify-content: center;
  background: #f0f0f0;
  img { width: 100%; height: 100%; object-fit: cover; }
}
.quin-bandera-ph {
  width: 100%; height: 100%;
  display: flex; align-items: center; justify-content: center;
  font-size: 10px; font-weight: 800; color: #999;
}
.quin-equipo-nombre {
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  color: #1a2e1a;
  max-width: 90px;
  line-height: 1.3;
}
.quin-centro {
  flex: 0 0 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}
.quin-marcador {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 28px;
  font-weight: 900;
  color: $verde-dark;
  line-height: 1;
  span { min-width: 28px; text-align: center; }
}
.quin-sep { color: #aaa; font-size: 22px; }
.quin-live-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}
.quin-live-dot {
  width: 10px; height: 10px;
  border-radius: 50%;
  background: #e74c3c;
  box-shadow: 0 0 6px rgba(231,76,60,0.6);
  animation: blink 1s ease-in-out infinite;
}
@keyframes blink {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.3; }
}
.quin-live-text {
  font-size: 11px;
  font-weight: 800;
  color: #e74c3c;
  letter-spacing: 1px;
}
.quin-vs-wrap { display: flex; align-items: center; }
.quin-vs {
  font-size: 16px;
  font-weight: 900;
  color: #ccc;
  letter-spacing: 3px;
}
.quin-apostar-footer {
  border-top: 1px solid #f0f0f0;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f9fdf9;
}
.quin-btn-apostar {
  background: linear-gradient(135deg, $verde, $verde2) !important;
  border-radius: 20px !important;
  font-weight: 700 !important;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 12px rgba(26,122,60,0.3) !important;
}
.quin-apuesta-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: $verde;
  font-weight: 700;
  background: #e8f5e9;
  border-radius: 20px;
  padding: 5px 14px;
}
.quin-apuesta-ticks {
  color: #888;
  font-weight: 500;
}

// ── TICKETS ───────────────────────────────────────────────────────────────────
.quin-tickets-header {
  font-size: 15px;
  color: $verde-dark;
  font-weight: 700;
  margin-bottom: 16px;
}
.quin-tickets-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}
.quin-ticket {
  background: white;
  border: none;
  border-radius: 14px;
  padding: 16px 10px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  position: relative;
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 4px;
    background: linear-gradient(90deg, $verde, $verde2);
  }
}
.quin-ticket-punch {
  width: 20px; height: 20px;
  border-radius: 50%;
  border: 2px dashed #ccc;
  margin-bottom: 4px;
}
.quin-tick-nro {
  font-size: 22px;
  font-weight: 900;
  color: $verde-dark;
}
.quin-tick-label {
  font-size: 9px;
  font-weight: 800;
  color: $verde;
  letter-spacing: 2px;
  text-transform: uppercase;
}
.quin-tick-fecha {
  font-size: 10px;
  color: #bbb;
}
.quin-tickets-select {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 10px 0;
}
.quin-tick-opt {
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  padding: 7px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 700;
  transition: all 0.18s;
  color: #666;
  &.selected {
    border-color: $verde;
    background: #e8f5e9;
    color: $verde;
    box-shadow: 0 2px 8px rgba(26,122,60,0.2);
  }
  &:hover:not(.selected) { border-color: #b2d9bc; background: #f5fbf6; }
}

// ── MIS APUESTAS ──────────────────────────────────────────────────────────────
.quin-apuesta-row {
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  margin-bottom: 12px;
  padding: 14px 18px;
  display: flex;
  align-items: center;
  gap: 14px;
  border-left: 4px solid #e0e0e0;
  transition: border-color 0.2s;
  &.con-puntos { border-left-color: $verde; }
}
.quin-apuesta-banderas {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  img { border-radius: 3px; box-shadow: 0 1px 4px rgba(0,0,0,0.15); }
}
.quin-apuesta-separador {
  font-size: 12px;
  color: #ccc;
}
.quin-apuesta-info {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1;
}
.quin-apuesta-partido {
  font-size: 14px;
  font-weight: 700;
  color: $verde-dark;
}
.quin-apuesta-prono {
  font-size: 13px;
  color: $verde;
  font-weight: 600;
}
.quin-apuesta-tickets {
  font-size: 11px;
  color: #aaa;
}
.quin-apuesta-puntos {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
  min-width: 60px;
  strong {
    font-size: 28px;
    font-weight: 900;
    color: $verde;
    line-height: 1;
  }
  span {
    font-size: 10px;
    color: #aaa;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
}
.quin-pend-chip {
  font-size: 11px;
  color: #999;
  background: #f5f5f5;
  padding: 4px 10px;
  border-radius: 10px;
  white-space: nowrap;
}

// ── TABLA ─────────────────────────────────────────────────────────────────────
.quin-tabla-header {
  display: grid;
  grid-template-columns: 48px 1fr 80px 70px;
  padding: 8px 20px;
  font-size: 10px;
  font-weight: 700;
  color: #aaa;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 6px;
}
.quin-tabla-row {
  background: white;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  margin-bottom: 8px;
  padding: 14px 20px;
  display: grid;
  grid-template-columns: 48px 1fr 80px 70px;
  align-items: center;
  transition: all 0.2s;
  &.quin-tabla-yo {
    border: 2px solid $verde;
    background: #f0f9f3;
    box-shadow: 0 4px 18px rgba(26,122,60,0.15);
  }
  &.pos-1 { background: linear-gradient(135deg, #fffdf0, #fffbe0); }
  &.pos-2 { background: linear-gradient(135deg, #fafafa, #f2f2f2); }
  &.pos-3 { background: linear-gradient(135deg, #fff8f2, #ffeedd); }
}
.quin-tabla-pos {
  font-size: 22px;
  text-align: center;
  min-width: 32px;
}
.quin-tabla-nombre {
  font-size: 14px;
  font-weight: 700;
  color: $verde-dark;
}
.quin-tabla-pts {
  display: flex;
  align-items: baseline;
  gap: 3px;
  strong {
    font-size: 22px;
    font-weight: 900;
    color: $verde;
  }
  span {
    font-size: 11px;
    color: #aaa;
  }
}
.quin-tabla-apuestas {
  font-size: 12px;
  color: #aaa;
  text-align: right;
}
</style>
